import { createSelector } from 'reselect';

const tripCriteriaSelector = ({ tripCriteria }) => tripCriteria || {};

const mainContactSelector = createSelector(
  tripCriteriaSelector,
  ({ mainContact }) => mainContact || {},
);
const getDepartureCity: (state: ReduxState) => string | null | undefined = createSelector(
  tripCriteriaSelector,
  ({ departureCity }) => departureCity,
);
const getDepartureDate: (state: ReduxState) => number | null | undefined = createSelector(
  tripCriteriaSelector,
  ({ departureDate }) => departureDate,
);
const getArrivalDate: (state: ReduxState) => number | null | undefined = createSelector(
  tripCriteriaSelector,
  ({ arrivalDate }) => arrivalDate,
);
const getMainContactOptinEmail = createSelector(
  mainContactSelector,
  ({ optinEmail }) => optinEmail,
);
const getMainContactOptinSms = createSelector(mainContactSelector, ({ optinSms }) => optinSms);
const getMainContactOptinMail = createSelector(mainContactSelector, ({ optinMail }) => optinMail);
const getMainContactOptinPhone = createSelector(
  mainContactSelector,
  ({ optinPhone }) => optinPhone,
);
const getMainContactOptinFosun = createSelector(
  mainContactSelector,
  ({ optinFosun }) => optinFosun,
);
const getTripDuration: (state: ReduxState) => number | null | undefined = createSelector(
  tripCriteriaSelector,
  ({ duration }) => duration,
);
const getTripFlexibility: (state: ReduxState) => number | null | undefined = createSelector(
  tripCriteriaSelector,
  ({ flexibility }) => flexibility,
);
export {
  getArrivalDate,
  getDepartureCity,
  getDepartureDate,
  getMainContactOptinEmail,
  getMainContactOptinSms,
  getMainContactOptinFosun,
  getMainContactOptinMail,
  getMainContactOptinPhone,
  getTripDuration,
  getTripFlexibility,
};
